import { useHistory, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import PermissionGroup from "../role/PermissionGroup";
import { Button, Card, Form, Input, InputNumber, Select } from "antd";
import RoleSelectBox from "../role/RoleSelectBox";
import { t } from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import FirmSelectList from "../firm/FirmSelectList";
import * as qz from "qz-tray";
import CashRegisterSelectList from "../cash-register/CashRegisterSelectList";

export default function UserCreateEdit() {
    const history = useHistory();
    const formRef = useRef();
    const { userId } = useParams();

    const [user, setUser] = useState({
        permissionIdList: []
    });

    const getUser = async () => {
        if (userId) {
            const res = await ApiService.User.GetUser(userId);
            if (res.success) {
                setUser(res.data);
                formRef.current.setFieldsValue({
                    ...res.data,
                    roleId: res.data.role.id,
                    firmIdList: res.data?.firmUsers?.map(x => x.firmId),
                    cashRegisterList: res.data?.userCashRegisters.map(x => x.cashRegisterId)
                })
            }
        }
    }

    const [selectedPrinter, setSelectedPrinter] = useState(null);
    const [loadingPrinters, setLoadingPrinters] = useState(false);
    const [showPrinterSelect, setShowPrinterSelect] = useState(false);
    const [printers, setPrinters] = useState([]);

    const listPrinters = async () => {
        try {
            setLoadingPrinters(true);

            if (!qz.websocket.isActive()) {
                await qz.websocket.connect({ verify: false });
            }

            const printerList = await qz.printers.find();
            setPrinters(printerList);

            if (printerList.length > 0 && !selectedPrinter) {
                setSelectedPrinter(printerList[0]);
            }
            setShowPrinterSelect(true);
        } catch (err) {
            alert("Yazıcı listesi alınamadı ❌");
            console.log('Liste hatası->', err);
        } finally {
            setLoadingPrinters(false);
        }
    };

    useEffect(() => {
        getUser();
    }, [])

    const save = async () => {
        if (userId) {
            const res = await ApiService.User.EditUser(userId, {
                ...formRef.current.getFieldsValue(),
                permissionIdList: user.permissionIdList
            })
        }
        else {
            const res = await ApiService.User.CreateUser({
                ...formRef.current.getFieldsValue(),
                permissionIdList: user.permissionIdList
            })

            if (res.success) {
                history.push(`/app/system/users/edit/${res.data}`)
            }
        }
    }

    return (
        <SimpleLayout>
            <Card
                title={!userId ? t('New User') : `${t('Edit User')} - ${user.name}`}
            >
                <Form
                    layout={'vertical'}
                    ref={formRef}
                    onFinish={save}
                >
                    <Form.Item
                        label={t('Firm')}
                        name={'firmIdList'}
                        rules={[{ required: true }]}
                    >
                        <FirmSelectList
                            all={true.toString()}
                            style={{ width: '100%' }}
                            allowClear={true}
                            mode={'multiple'}
                        />
                    </Form.Item>

                    <Form.Item
                        label={t('Username')}
                        name={'username'}
                        rules={[
                            { type: "regexp", pattern: new RegExp("^[0-9]*$"), },
                            { required: true }
                        ]}
                    >
                        <Input disabled={userId} />
                    </Form.Item>

                    <Form.Item
                        label={t('Email')}
                        name={'email'}
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={t('Name')}
                        name={'name'}
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={t('Password')}
                        name={'password'}
                        rules={[{ required: !userId }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={t('Cash Registers')}
                        name={'cashRegisterList'}
                    >
                        <CashRegisterSelectList
                            mode={'multiple'}
                            style={{ width: '100%' }}
                            all={true}
                        />
                    </Form.Item>

                    {userId && (
                        <Form.Item
                            label={t('Enabled')}
                            name={'enabled'}
                            rules={[{ required: true }]}
                        >
                            <Select
                                style={{ width: '100%' }}
                                options={[
                                    { value: true, label: t('Active') },
                                    { value: false, label: t('Passive') }
                                ]}
                            />
                        </Form.Item>
                    )}


                    {/*<Form.Item*/}
                    {/*    label={t('Discount')}*/}
                    {/*    name={'discount'}*/}
                    {/*    required={true}*/}
                    {/*>*/}
                    {/*    <InputNumber />*/}
                    {/*</Form.Item>*/}

                    <Form.Item
                        label={t('Role')}
                        name={'roleId'}
                        rules={[{ required: true }]}
                    >
                        <RoleSelectBox />
                    </Form.Item>
                    <Form.Item
                        label={t('Printer')}
                        name={'printerName'}
                    >
                        <Select
                            style={{ width: '100%' }}
                            loading={loadingPrinters}
                            onDropdownVisibleChange={(open) => {
                                // Selectbox açıldığında listeyi çek
                                if (open && printers.length === 0) {
                                    listPrinters();
                                }
                            }}
                            placeholder={t('Select Printer')}
                            value={selectedPrinter}
                            onChange={(val) => setSelectedPrinter(val)}
                        >
                            {printers.map((printer) => (
                                <Select.Option key={printer} value={printer}>
                                    {printer}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={t('Other Permissions')}
                        name={'permissionIdList'}
                    >
                        <PermissionGroup
                            selectedPermissions={user.permissionIdList}
                            onChangeSelectedPermissions={(permissions) => {
                                setUser({
                                    ...user,
                                    permissionIdList: permissions
                                })
                            }}
                        />
                    </Form.Item>
                    <br />

                    <Form.Item>
                        <Button htmlType={'submit'} type={'primary'}>{t('Save')}</Button>
                    </Form.Item>
                </Form>
            </Card>
        </SimpleLayout>
    )
}
